var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContactUsThanksHero',{attrs:{"header":"CONTACT US","paragraph":"Thank you for your request. A member of our sun safety squad will be getting back to you soon. Pending","image":"super-hero-4.gif"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }